
import { Component, Prop, Emit, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import SignInModalFrame from './_SignInModalFrame.vue';
import { iCheckIn } from '@/interface/prize';
@Component({
  components: {
    SignInModalFrame,
  },
})
export default class signModal extends Vue {
  @Prop() private visible!: boolean;
  @Prop() private signInfo!: iCheckIn;
  @Emit() private close() {}
}
